const gameOverDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                language = 'en'
            }
        } = state;
        return Promise.allSettled([
            componentDataEngine.fetch('ruleSettings', { gamePk, language }),
            componentDataEngine.fetch('schedule', { gamePk, language })
        ]).then(([ruleSettingsRes, scheduleRes]) => {
            componentDataEngine.store(ruleSettingsRes.value);
            componentDataEngine.store(scheduleRes.value);
        });
    };
};

export default gameOverDataRequestAction;
